import { GridConfig } from './responsive.interfaces';

export const skipLinksLayoutConfig: Record<'desktop' | 'mobile', GridConfig> = {
  desktop: {
    grid: {
      padding: '104px',
      columns: 12,
    },
    columns: {
      menuContent: {
        end: 12,
      },
    },
  },
  mobile: {
    grid: {
      padding: '16px',
      columns: 4,
    },
    columns: {
      menuContent: {
        end: 4,
      },
    },
  },
};
